<template>
  <Panel toggleable collapsed>
    <template #header>
      <h4
        class="py-2 print-h4 text-nash-midnightBlue700 flex flex-row items-center gap-2"
      >
        <TIcon name="header-icon" icon="wrench" />
        AI Dev Tools
      </h4>
    </template>
    <LegacyTTextarea
      v-model="modelValue.system"
      :disabled="loading"
      name="system-input"
      label="System instructions"
      :rows="2"
      placeholder="Default"
    />
    <div class="flex flex-row gap-2 items-center">
      <TInputText
        :model-value="modelValue.temperature?.toString()"
        :disabled="loading"
        name="temperature-input"
        label="Temperature (0-2)"
        type="number"
        tooltip="Higher values make the output more random, lower values make it more deterministic."
        placeholder="Default"
        @update:model-value="setTemperature"
      />
      <TInputText
        :model-value="modelValue.maxResponseTokens?.toString()"
        :disabled="loading"
        name="max-tokens-input"
        label="Max Tokens"
        type="number"
        tooltip="Max number of tokens (~words) included in the response"
        placeholder="Default"
        @update:model-value="setMaxResponseTokens"
      />
      <div class="block-inline">
        <label for="llm-model" class="input-label block">Model</label>
      </div>
      <TDropdown
        v-model="modelValue.model"
        :disabled="loading"
        name="llm-model"
        placeholder="Default"
        option-label="label"
        option-value="value"
        :options="llmModelDropdownOptions"
        class="bg-nash-neutral000"
      />
    </div>
    <slot></slot>
  </Panel>
</template>

<script lang="ts">
import TInputText from '@nashville/forms/TInputText/TInputText.vue'
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import Panel from 'primevue/panel'
import { defineComponent } from 'vue'
import TDropdown from '@/legacy/nashville/dropdown/TDropdown.vue'
import LegacyTTextarea from '@/legacy/nashville/input/LegacyTTextarea.vue'
import { setup } from './controller'
import { LLM_DEV_TOOLS_PROPS } from './types'

export default defineComponent({
  components: { Panel, TIcon, TDropdown, LegacyTTextarea, TInputText },
  props: LLM_DEV_TOOLS_PROPS,
  setup,
})
</script>
